export const AUTH_CONSTANTS = {
  ROLES: {
    SUPER_ADMIN: 'admin',
    DEALER_ADMIN: 'dealer_admin',
    ADMIN: 'client_admin',
    USER: 'client_user',
  },
} as const;

export type UserRole = (typeof AUTH_CONSTANTS.ROLES)[keyof typeof AUTH_CONSTANTS.ROLES];

export const ROLE_DISPLAY_MAPPING = {
  [AUTH_CONSTANTS.ROLES.SUPER_ADMIN]: 'SUPER_ADMIN',
  [AUTH_CONSTANTS.ROLES.DEALER_ADMIN]: 'DEALER_ADMIN',
  [AUTH_CONSTANTS.ROLES.ADMIN]: 'ADMIN',
  [AUTH_CONSTANTS.ROLES.USER]: 'USER',
} as const;

export const ROLES = [
  { value: 'client_admin', label: 'Admin' },
  { value: 'client_user', label: 'User' },
];

// Roles available when super admin creates users (includes DEALER_ADMIN)
export const SUPER_ADMIN_ROLES = [
  { value: 'dealer_admin', label: 'Dealer Admin' },
  { value: 'client_admin', label: 'Admin' },
  { value: 'client_user', label: 'User' },
];
